export const INSTAGRAM = 'instagram'
export const FACEBOOK = 'facebook'
export const TIKTOK = 'tiktok'
export const PINTEREST = 'pinterest'

export const TIKTOK_MAX_LENGTH = 100
